module.exports = __webpack_public_path__ + "media/images/show-template-button-ec99bd9c.gif";